var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6532 12.8817V11.7107H22.9689V10.5396H27.6532V0H3.06089V10.5396H7.74512V11.7107H3.06089V12.8817H1.88982V16.3949H0.71875V21.0792H1.88982V22.2503H3.06089V36.3031H27.6532V22.2503H28.8242V21.0792H29.9953V16.3949H28.8242V12.8817H27.6532ZM7.74512 9.36853H26.4821H4.23196H7.74512ZM8.91619 10.5396H10.0872V11.7107H8.91619V10.5396ZM11.2583 10.5396H19.4557V11.7107H11.2583V10.5396ZM20.6268 10.5396H21.7979V11.7107H20.6268V10.5396ZM5.403 21.0792L1.88982 21.0792V16.3949L3.06089 16.395V12.8817H6.57407V16.3949H5.403V21.0792ZM27.6532 12.8817V16.3949H28.8242V21.0792H25.3111V16.3949H24.14V12.8817H27.6532ZM6.57407 16.3949H7.74512V12.8817H10.0873V21.0792H6.57407V16.3949ZM11.2583 12.8817H14.7715V21.0792H11.2583V12.8817ZM15.9426 12.8817H19.4557V21.0792H15.9426V12.8817ZM20.6268 12.8817H22.9689V16.3949H24.14L24.14 21.0792H20.6268V12.8817ZM8.91619 22.2503H12.4294V24.5924H8.91619V22.2503ZM13.6004 22.2503H17.1136V24.5924H13.6004V22.2503ZM18.2847 22.2503H21.7979V24.5924H18.2847V22.2503ZM8.91619 25.7635H11.2583V28.105H8.91619V25.7635ZM12.4294 25.7635H14.7715V28.105H12.4294V25.7635ZM15.9426 25.7635H18.2847V28.105H15.9426V25.7635ZM19.4557 25.7635H21.7979V28.105H19.4557V25.7635ZM12.4294 35.132H10.0873V29.2767H11.2583V28.105H12.4294L12.4294 29.2767H14.7715L14.7715 28.105H15.9426V29.2767H18.2847V28.105H19.4557L19.4557 29.2767H20.6268V35.132H18.2847V30.4478H12.4294V35.132ZM4.23196 22.2503H7.74514V28.1051H8.91621V35.132H4.23196V22.2503ZM13.6004 31.6188H17.1136V35.132H13.6004V31.6188ZM21.7979 28.105H22.9689V22.2503H26.4821V35.132H21.7979L21.7979 28.105Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9679 28.1047H21.7969V35.1317H26.4811V22.25H22.9679V28.1047Z",
    fill: "#CE986E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23438 35.1317H8.91861V28.1047H7.74754V22.25H4.23438V35.1317Z",
    fill: "#CE986E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.257 29.2771H10.0859V35.1325H12.4281V30.4482H18.2834V35.1325H20.6255V29.2771H19.4544V28.1055H18.2834V29.2771H15.9412V28.1055H14.7702V29.2771H12.4281V28.1055H11.257V29.2771Z",
    fill: "#758397"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06169 16.3921H1.89062V21.0764H5.40381V16.3921H6.57488V12.8789H3.06169V16.3921Z",
    fill: "#E6B389"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6538 12.8789H24.1406V16.3921H25.3117V21.0764H28.8249V16.3921H27.6538V12.8789Z",
    fill: "#F05A6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.771 12.8789H11.2578V21.0764H14.771V12.8789Z",
    fill: "#E6B389"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4507 12.8789H15.9375V21.0764H19.4507V12.8789Z",
    fill: "#F05A6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.625 21.0764H24.1382V16.3921H22.9671V12.8789H20.625V21.0764Z",
    fill: "#E6B389"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74136 16.3921H6.57031V21.0764H10.0835V12.8789H7.74136V16.3921Z",
    fill: "#F05A6C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1147 31.6211H13.6016V35.1343H17.1147V31.6211Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7944 22.25H18.2812V24.5921H21.7944V22.25Z",
    fill: "#CE986E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1147 22.25H13.6016V24.5921H17.1147V22.25Z",
    fill: "#CE986E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4272 22.25H8.91406V24.5921H12.4272V22.25Z",
    fill: "#CE986E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7953 25.7656H19.4531V28.1072H21.7953V25.7656Z",
    fill: "#A3B0C3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2562 25.7656H8.91406V28.1072H11.2562V25.7656Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2796 25.7656H15.9375V28.1072H18.2796V25.7656Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7718 25.7656H12.4297V28.1072H14.7718V25.7656Z",
    fill: "#A3B0C3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.796 10.5391H20.625V11.7101H21.796V10.5391Z",
    fill: "#758397"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0851 10.5391H8.91406V11.7101H10.0851V10.5391Z",
    fill: "#758397"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57989 5.79054H9.20785V3.1862H9.57989V3.55825H9.76592V3.74427H9.95194V3.9303H10.324V3.74427H10.51V3.55825H10.696V3.1862H11.0681V5.79054H10.696V4.11632H10.51V4.30235H10.324V4.67439H9.95194V4.30235H9.76592V4.11632H9.57989V5.79054ZM11.8122 4.67439H12.9283V4.11632H12.7423V3.9303H12.5563V3.74427H12.1842V3.9303H11.9982V4.11632H11.8122V4.67439ZM11.8122 5.79054H11.4401V3.9303H11.6262V3.74427H11.8122V3.55825H11.9982V3.37223H12.1842V3.1862H12.5563V3.37223H12.7423V3.55825H12.9283V3.74427H13.1144V3.9303H13.3004V5.79054H12.9283V5.04644H11.8122V5.79054ZM14.0445 3.55825V4.30235H14.9746V4.11632H15.1606V3.74427H14.9746V3.55825H14.0445ZM14.2305 4.67439H14.0445V5.79054H13.6724V3.1862H15.1606V3.37223H15.3466V3.55825H15.5327V4.30235H15.3466V4.48837H15.1606V4.67439H14.7886V4.86042H14.9746V5.04644H15.1606V5.23247H15.3466V5.41849H15.5327V5.79054H15.1606V5.60451H14.9746V5.41849H14.7886V5.23247H14.6025V5.04644H14.4165V4.86042H14.2305V4.67439ZM16.2768 4.67439V5.79054H15.9047V3.1862H16.2768V4.30235H16.4628V4.11632H16.6488V3.9303H16.8348V3.74427H17.0209V3.55825H17.2069V3.37223H17.3929V3.1862H17.765V3.55825H17.5789V3.74427H17.3929V3.9303H17.2069V4.11632H17.0209V4.30235H16.8348V4.67439H17.0209V4.86042H17.2069V5.04644H17.3929V5.23247H17.5789V5.41849H17.765V5.79054H17.3929V5.60451H17.2069V5.41849H17.0209V5.23247H16.8348V5.04644H16.6488V4.86042H16.4628V4.67439H16.2768ZM19.9972 3.1862V3.55825H18.509V4.30235H19.6252V4.67439H18.509V5.41849H19.9972V5.79054H18.137V3.1862H19.9972ZM21.1134 3.55825H20.3693V3.1862H22.2295V3.55825H21.4854V5.79054H21.1134V3.55825Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketp);
export default __webpack_public_path__ + "static/media/marketp.a4dfc59e04b9038486eefcf97f97aeda.svg";
export { ForwardRef as ReactComponent };